import { toast } from "sonner";
import {
  ToastProgressBar,
  TOAST_CLASSNAMES,
  TOAST_DESCRIPTION_PROGRESS_CLASS,
} from "@/components/molecules/toast";
import {
  SPARXS_EDITOR_UNAVAILABLE_TOAST,
  SPARXS_EDITOR_UNAVAILABLE_TOAST_ID,
} from "@/constants/toastCopy";

const SUCCESS_DURATION_MS = 5000;

const warningToastClasses = `${TOAST_CLASSNAMES.base} pb-0`;

/** Catalog list failed or blueprint fetch failed off-route; matches sidebar blocked UX. */
export const showSparxsEditorEntryUnavailableToast = (): void => {
  toast.warning(SPARXS_EDITOR_UNAVAILABLE_TOAST, {
    id: SPARXS_EDITOR_UNAVAILABLE_TOAST_ID,
    duration: SUCCESS_DURATION_MS,
    description: <ToastProgressBar duration={SUCCESS_DURATION_MS} />,
    classNames: {
      toast: warningToastClasses,
      description: TOAST_DESCRIPTION_PROGRESS_CLASS,
    },
  });
};
